import React from 'react';

function Header() {
  return (
    <div data-container="" className="id-atf-menu" id="Menu">
      <div data-container="">
        <img 
          data-image="" 
          className="logo-img" 
          src="https://via.placeholder.com/166x58?text=CabazNatura" 
          alt="Cabaz Natura"
        />
      </div>
      <div data-container="">
        <button data-button="" className="btn" type="button">
          Sobre nós
        </button>
        <button data-button="" className="btn" type="button">
          Como Funciona
        </button>
        <button data-button="" className="btn" type="button">
          Cabaz da Semana
        </button>
        <button data-button="" className="btn" type="button">
          Contactos
        </button>
      </div>
      <div data-container="" className="menu-user-info">
        <a data-link="" href="#">
          <img 
            data-image="" 
            src="https://via.placeholder.com/24x24?text=👤" 
            alt="User"
          />
        </a>
      </div>
    </div>
  );
}

export default Header;

